import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

import moment from 'moment';
declare var require: any;

@Component({
  selector: 'app-worker-short-shift',
  templateUrl: './worker-short-shift.component.html',
  styleUrls: ['./worker-short-shift.component.scss']
})
export class WorkerShortShiftComponent implements OnInit {

  workers: any;

  monitor = '';
  group = '';

  monitors:any = [];
  groups:any = [];

  filter: any;
  selected: any;

  u = Utils;

  constructor(private router: Router,private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() }
    this.getWorkers();

  }

  getWorkers(){

    this.filter = [];

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    this.filter['start'] = this.selected.startDate.format("YYYY-MM-DD");
    this.filter['end'] = this.selected.endDate.format("YYYY-MM-DD");

    this.okService.get('reports/workershortshift', {monitor:this.monitor,group:this.group,start:this.filter['start'],end:this.filter['end']})
    .subscribe((data) => {
      //console.log('data',data);
      this.workers = data.body;
      this.groups = this.okService.groups;
      this.monitors = this.okService.monitors;
      //console.log('workers',this.workers);
      //console.log('groups', this.groups);
      //console.log('monitors',this.monitors);

    });
  }

  updateFilter(){
    this.getWorkers();
  }

  clearFilter(){
    this.monitor = '';
    this.group = '';
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };
    this.updateFilter();
  }

  export(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    let fields:any = {'export':true};
    fields['start'] = this.selected.startDate.format("YYYY-MM-DD");
    fields['end'] = this.selected.endDate.format("YYYY-MM-DD");
    fields['monitor'] = this.monitor;
    fields['group'] = this.group;

    this.okService.download("reports/workershortshift",fields);

  }

}
